export default class ProcessadorTelaOpcao {
    /**
     * Processa os dados de uma tela de opções retornando o nome da próxima tela.
     * @param dados dados a serem processados. Neste caso é a opção escolhida.
     * @returns Pŕoxima tela
     */
    processar({dados}) {
        return dados.tela;
    }
}